import React, { Component } from "react";
import { Tabs, Icon, Badge, Table, Button, Spin, message, Modal, Progress, Tooltip } from "antd";
import moment from "moment";
import ApplyQueryTable from "../../components/applyQueryTable";
import Patient from "./components/patientModal";
import ApplyConsulation from "./components/applyConsulation";
import EcgStartReport from "../../components/ecgStartReport";
import Bookmark from "./bookmark";
import StartCheck from "./components/startCheck";
import star from "../../assets/image/star.png";
import replyicon from "../../assets/image/replyicon.png";
import noapplyicon from "../../assets/image/noapplyicon.png";
import accept from "../../assets/image/accept.png";
import receiving from "../../assets/image/pljs.png";
import addReferral from "@/assets/image/addReferral.png";
import exportExcel from "@/assets/image/exportExcel.png";
import tqxyIcon from "../../assets/image/tqxy.png";
import easyCreateIcon from "../../assets/image/easyCreateIcon.png";
import critical from "../../assets/image/critical.png";
import cancelcritical from "../../assets/image/cancelcritical.png";
import dangerFlag from "../../assets/image/dangerFlag.png";
import { getFileStatus, fileStatus, getCommonColumnInfoFn, requestErrorLog } from "../../common/util";
import { sendMessage, receiveMessage } from "@/request/websocket";
import EditTable from "../../components/editTable/index";
import CriticalCaseInfo from "./criticalModal";
import DeepSeekModal from "./components/deepSeekModal";
import {
  deleteReport,
  urging,
  canceAppointment,
  checkExam,
  cancelCollect,
  printPic,
  deleteWaitImproved,
  getExamItem,
  cancelCriticalCase,
} from "@/request/api";
import "./remoteApply.scss";
import backicon from "../../assets/image/back.png";
import BatchReceive from "./components/batchReceive";
import { initWebSocket } from "../../request/websocket";
import RevokeConsultant from "../remoteConsulation/revokeConsultant";

const { TabPane } = Tabs;
const { confirm } = Modal;

class RemoteApply extends Component {
  // 远程申请
  constructor(props) {
    super(props);
    this.state = {
      queryTableData: [],
      isModalVisible: false,
      visible: false,
      applyVisible: false,
      title: "",
      clickStatus: "",
      selectedRows: [],
      selectedRowKeys: [],
      rowData: "", // 当前行
      applyType: "",
      selectedKeys: "",
      applyCount: "",
      percent: 10,
      bookmarkVisible: false,
      rowsData: [], //多行数据,
      isEdit: false,
      bookmarkdetail: "",
      checkVisible: false,
      RowCount: 0,
      PageNo: 1,
      PageSize: 10,
      transmiMsg: "",
      transmiRate: 0,
      selectExamUids: [],
      uploadError: [],
      waitingExamUids: [],
      openExamUids: [],
      copyExamUids: [],
      reportExamUids: [],
      cancelMonitoring: [],
      loadingList: [],
      canRefresh: false,
      ecgStartReportBtn: false,
      showKey: this.props.applyTabskey, //检查类型
      showColumn: false, //编辑表头,
      batchReceiveVisible: false, //批量检查弹框
      revokeVisible: false,
      sucBatchMsg: "", //批量接收成功
      errBatchMsg: "", //批量接收失败
      infoBatchMsg: "", //存在转换失败的数据
      getBatchNum: {}, //批量接收数
      commonColumn: [],
      initCommonColumn: [
        {
          title: "序号",
          dataIndex: "title",
          key: "title",
          width: 80,
          align: "center",
          isShow: true, //表头列合
          render: (text, record, index) => {
            //生成序号
            return <span>{(this.state.PageNo - 1) * 10 + (index + 1)}</span>;
          },
        },
        {
          title: "报告解读",
          dataIndex: "reportAI",
          key: "reportAI",
          width: 120,
          isShow: true,
          align: "center",
          render: (text, record) => {
            return record.CONSULTATION_STATUS === "已会诊" ? (
              <Button onClick={() => this.getDeepSeek(record, 0)} className="AIBottonClass">
                一键解读
              </Button>
            ) : null;
          },
        },
        {
          title: "诊疗建议",
          dataIndex: "suggestAI",
          key: "suggestAI",
          width: 120,
          isShow: true,
          align: "center",
          render: (text, record) => {
            return record.CONSULTATION_STATUS === "已会诊" ? (
              <Button onClick={() => this.getDeepSeek(record, 1)} className="AIBottonClass">
                查看建议
              </Button>
            ) : null;
          },
        },
        {
          title: "申请会诊",
          dataIndex: "view",
          key: "view",
          width: 120,
          isShow: true,
          align: "center",
          render: (text, record) => {
            const custService = JSON.parse(localStorage.getItem("QUERY_ALL"));
            return custService !== 1 ? (
              <Button onClick={(e) => this.handleApply(record, e)} style={{ color: "#fff" }}>
                申请会诊
              </Button>
            ) : null;
          },
        },
        {
          title: "传输状态",
          dataIndex: "Progress",
          key: "Progress",
          width: 160,
          isShow: true,
          align: "center",
          render: (text, record) => {
            let loadingList = JSON.parse(JSON.stringify(this.state.loadingList));
            if (loadingList.some((item) => item.EXAM_UID === record.EXAM_UID)) {
              let value = loadingList.filter((item) => item.EXAM_UID === record.EXAM_UID)[0];
              if (value.RETURN_RATE) {
                return (
                  <div>
                    {value.RETURN_MSG === "已报告" ? "" : value.RETURN_MSG}
                    {value.RETURN_RATE && value.RETURN_MSG !== "已报告" ? (
                      <Progress percent={parseInt(value.RETURN_RATE)} size="small" />
                    ) : null}
                  </div>
                );
              } else {
                return <div>{value.RETURN_MSG}</div>;
              }
            }
          },
        },
        {
          title: "状态标记",
          dataIndex: "EXIT_FLAG",
          key: "EXIT_FLAG",
          width: 80,
          isShow: true,
          align: "center",
          render: (val, record) => {
            return (
              <div className="statusFlag">
                {record.EXIT_FLAG === "2" && <img key="backicon" src={backicon} alt={"退回"} className="returnFlag" />}
                {record.DANGER_FLAG === 1 && (
                  <img key="dangerFlag" src={dangerFlag} alt={"危险"} className="dangerFlag" />
                )}
              </div>
            );
          },
        },
        {
          title: "报告状态",
          dataIndex: "EXAM_STATUS_NAME",
          key: "EXAM_STATUS_NAME",
          align: "center",
          width: 80,
          isShow: true,
          render: (exam) => (
            <span
              style={{
                color:
                  exam === "已审核"
                    ? "#17CC60"
                    : exam === "已报告"
                    ? "#1A92FF"
                    : exam === "未报告" || exam === "解析中" || exam === "解析失败"
                    ? "#FF4045"
                    : "#000000a6",
              }}
            >
              {exam}
            </span>
          ),
        },
        {
          title: "会诊状态",
          dataIndex: "CONSULTATION_STATUS",
          key: "CONSULTATION_STATUS",
          align: "center",
          width: 80,
          isShow: true,
          render: (exam) => (
            <span
              style={{
                color:
                  exam === "已会诊"
                    ? "#17CC60"
                    : exam === "会诊中"
                    ? "#1A92FF"
                    : exam === "未会诊"
                    ? "#FF4045"
                    : exam === "撤销中"
                    ? "#FFA500"
                    : "#000000a6",
              }}
            >
              {exam}
            </span>
          ),
        },
        {
          title: "打印状态",
          dataIndex: "PRINT_STATUS",
          key: "PRINT_STATUS",
          align: "center",
          width: 80,
          isShow: true,
          render: (exam) => <span style={{ color: exam === "已打印" ? "#17CC60" : "#FF4045" }}>{exam}</span>,
        },
        {
          title: "姓名",
          dataIndex: "NAME",
          key: "NAME",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "性别",
          dataIndex: "SEX_NAME",
          key: "SEX_NAME",
          align: "center",
          width: 80,
          isShow: true,
        },
        {
          title: "年龄",
          dataIndex: "AgeDisPlay",
          key: "AgeDisPlay",
          align: "center",
          width: 60,
          isShow: true,
        },
        {
          title: "出生日期",
          dataIndex: "BIRTHDAY",
          key: "BIRTHDAY",
          align: "center",
          width: 110,
          isShow: true,
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD")}</span>,
        },
        {
          title: "手机号",
          dataIndex: "CONTACT_TEL",
          key: "CONTACT_TEL",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "病历号",
          dataIndex: "PATIENT_ID",
          key: "PATIENT_ID",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "患者症状",
          dataIndex: "PATIENT_SYMPTOM",
          key: "PATIENT_SYMPTOM",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "诊疗建议",
          dataIndex: "EXAM_SUGGEST",
          key: "EXAM_SUGGEST",
          align: "center",
          width: 120,
          isShow: false,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "门诊号",
          dataIndex: "OUTP_NO",
          key: "OUTP_NO",
          align: "center",
          width: 120,
          isShow: false,
        },
        {
          title: "住院号",
          dataIndex: "INP_NO",
          key: "INP_NO",
          align: "center",
          width: 120,
          isShow: false,
        },
        {
          title: "病区",
          dataIndex: "ROOM_NO",
          key: "ROOM_NO",
          align: "center",
          width: 120,
          isShow: false,
        },
        {
          title: "床号",
          dataIndex: "BED_NO",
          key: "BED_NO",
          align: "center",
          width: 80,
          isShow: false,
        },
        {
          title: "开单医生",
          dataIndex: "BILLING_DOCTOR",
          key: "BILLING_DOCTOR",
          align: "center",
          width: 80,
          isShow: true,
        },
        {
          title: "创建时间",
          dataIndex: "REQ_DATETIME",
          key: "REQ_DATETIME",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.REQ_DATETIME).getTime() - new Date(b.REQ_DATETIME).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },
        {
          title: "检查时间",
          dataIndex: "EXAM_DATETIME",
          key: "EXAM_DATETIME",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.EXAM_DATETIME).getTime() - new Date(b.EXAM_DATETIME).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },
        {
          title: "申请科室",
          dataIndex: "REQ_DEPT_NAME",
          key: "REQ_DEPT_NAME",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "申请人",
          dataIndex: "APPLY_DOCTOR_NAME",
          key: "APPLY_DOCTOR_NAME",
          align: "center",
          width: 100,
          isShow: true,
        },
        {
          title: "申请会诊时间",
          dataIndex: "APPLY_DATETIME",
          key: "APPLY_DATETIME",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.APPLY_DATETIME).getTime() - new Date(b.APPLY_DATETIME).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },
        {
          title: "患者来源",
          dataIndex: "PATIENT_SOURCE_NAME",
          key: "PATIENT_SOURCE_NAME",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "会诊医院",
          dataIndex: "CONSULTATION_HOSPITAL_NAME",
          key: "CONSULTATION_HOSPITAL_NAME",
          align: "center",
          width: 130,
          isShow: true,
          ellipsis: true,
          render: (text, record) => (record.CONSULTATION_STATUS !== "未申请" ? text : ""),
        },
        {
          title: "报告人",
          dataIndex: "REPORT_DOCTOR_NAME",
          key: "REPORT_DOCTOR_NAME",
          align: "center",
          width: 100,
          isShow: true,
        },
        {
          title: "报告时间",
          dataIndex: "REPORT_DATETIME",
          key: "REPORT_DATETIME",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.REPORT_DATETIME).getTime() - new Date(b.REPORT_DATETIME).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },
        {
          title: "审核人",
          dataIndex: "CHECK_DOCTOR_NAME",
          key: "CHECK_DOCTOR_NAME",
          align: "center",
          width: 100,
          isShow: true,
        },
        {
          title: "审核时间",
          dataIndex: "CHECK_DATETIME",
          key: "CHECK_DATETIME",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.CHECK_DATETIME).getTime() - new Date(b.CHECK_DATETIME).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },
        {
          title: "完成会诊时间",
          dataIndex: "CONSULTATION_DATE",
          key: "CONSULTATION_DATE",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.CONSULTATION_DATE).getTime() - new Date(b.CONSULTATION_DATE).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },
        {
          title: "危急值信息",
          dataIndex: "DANGER_MSG",
          key: "DANGER_MSG",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="left" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "检查结论",
          dataIndex: "CONCLUSIONS",
          key: "CONCLUSIONS",
          align: "center",
          width: 160,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "检查项目",
          dataIndex: "ITEM_NAME",
          key: "ITEM_NAME",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "退回原因",
          dataIndex: "REJECT_REASON",
          key: "REJECT_REASON",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "退回日志",
          dataIndex: "CONSULTATION_LOG",
          key: "CONSULTATION_LOG",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "书签",
          dataIndex: "COLLECT_TAG",
          key: "COLLECT_TAG",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
      ],
      waitColumn: [
        {
          title: "编码",
          dataIndex: "FILE_UID",
          key: "FILE_UID",
          align: "center",
          width: 80,
          isShow: true,
        },
        {
          title: "姓名",
          dataIndex: "NAME",
          key: "NAME",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "性别",
          dataIndex: "SEX_NAME",
          key: "SEX_NAME",
          align: "center",
          width: 80,
          isShow: true,
        },
        {
          title: "年龄",
          dataIndex: "AgeDisPlay",
          key: "AgeDisPlay",
          align: "center",
          width: 60,
          isShow: true,
        },
        {
          title: "出生日期",
          dataIndex: "BIRTHDAY",
          key: "BIRTHDAY",
          align: "center",
          width: 110,
          isShow: true,
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD")}</span>,
        },
        {
          title: "检查时间",
          dataIndex: "EXAM_DATETIME",
          key: "EXAM_DATETIME",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.EXAM_DATETIME).getTime() - new Date(b.EXAM_DATETIME).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },
      ],
      equipmentType: localStorage.getItem("equipmentType"),
      electroencephalogramCommonColumn: [],
      initElectroencephalogramCommonColumn: [
        {
          title: "序号",
          dataIndex: "title",
          key: "title",
          width: 80,
          align: "center",
          isShow: true, //表头列合
          render: (text, record, index) => {
            //生成序号
            return <span>{(this.state.PageNo - 1) * 10 + (index + 1)}</span>;
          },
        },
        {
          title: "传输状态",
          dataIndex: "Progress",
          key: "Progress",
          width: 160,
          isShow: true,
          align: "center",
          render: (text, record) => {
            let loadingList = JSON.parse(JSON.stringify(this.state.loadingList));
            if (loadingList.some((item) => item.EXAM_UID === record.EXAM_UID)) {
              let value = loadingList.filter((item) => item.EXAM_UID === record.EXAM_UID)[0];
              if (value.RETURN_RATE) {
                return (
                  <div>
                    {value.RETURN_MSG === "已报告" ? "" : value.RETURN_MSG}
                    {value.RETURN_RATE && value.RETURN_MSG !== "已报告" ? (
                      <Progress percent={parseInt(value.RETURN_RATE)} size="small" />
                    ) : null}
                  </div>
                );
              } else {
                return <div>{value.RETURN_MSG}</div>;
              }
            }
          },
        },
        {
          title: "报告状态",
          dataIndex: "EXAM_STATUS_NAME",
          key: "EXAM_STATUS_NAME",
          align: "center",
          width: 80,
          isShow: true,
          render: (exam) => (
            <span
              style={{
                color:
                  exam === "已审核"
                    ? "#17CC60"
                    : exam === "已报告"
                    ? "#1A92FF"
                    : exam === "未报告"
                    ? "#FF4045"
                    : "#000000a6",
              }}
            >
              {exam}
            </span>
          ),
        },

        {
          title: "姓名",
          dataIndex: "NAME",
          key: "NAME",
          align: "center",
          width: 120,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "性别",
          dataIndex: "SEX_NAME",
          key: "SEX_NAME",
          align: "center",
          width: 80,
          isShow: true,
        },
        {
          title: "年龄",
          dataIndex: "AgeDisPlay",
          key: "AgeDisPlay",
          align: "center",
          width: 60,
          isShow: true,
        },
        {
          title: "出生日期",
          dataIndex: "BIRTHDAY",
          key: "BIRTHDAY",
          align: "center",
          width: 110,
          isShow: true,
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD")}</span>,
        },
        {
          title: "手机号",
          dataIndex: "CONTACT_TEL",
          key: "CONTACT_TEL",
          align: "center",
          width: 120,
          isShow: true,
        },

        {
          title: "病历号",
          dataIndex: "PATIENT_ID",
          key: "PATIENT_ID",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "门诊号",
          dataIndex: "OUTP_NO",
          key: "OUTP_NO",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "住院号",
          dataIndex: "INP_NO",
          key: "INP_NO",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "病区",
          dataIndex: "ROOM_NO",
          key: "ROOM_NO",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "床号",
          dataIndex: "BED_NO",
          key: "BED_NO",
          align: "center",
          width: 80,
          isShow: true,
        },

        {
          title: "患者来源",
          dataIndex: "PATIENT_SOURCE_NAME",
          key: "PATIENT_SOURCE_NAME",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "检查时间",
          dataIndex: "EXAM_DATETIME",
          key: "EXAM_DATETIME",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.EXAM_DATETIME).getTime() - new Date(b.EXAM_DATETIME).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },

        {
          title: "检查结论",
          dataIndex: "CONCLUSIONS",
          key: "CONCLUSIONS",
          align: "center",
          width: 160,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },

        // {
        //   title: "书签",
        //   dataIndex: "COLLECT_TAG",
        //   key: "COLLECT_TAG",
        //   align: 'center',
        //   width: 120,
        //   isShow: true,
        //   ellipsis: true,
        //   render: (text) => {
        //     return (
        //       <Tooltip placement="topLeft" title={text}>
        //         <span>{text}</span>
        //       </Tooltip>
        //     )
        //   }
        // },
      ],
      tranquillizationBloodColumn: [],
      initTranquillizationBloodColumn: [
        {
          title: "序号",
          dataIndex: "title",
          key: "title",
          width: 80,
          align: "center",
          isShow: true, //表头列合
          render: (text, record, index) => {
            //生成序号
            return <span>{(this.state.PageNo - 1) * 10 + (index + 1)}</span>;
          },
        },
        {
          title: "姓名",
          dataIndex: "NAME",
          key: "NAME",
          align: "center",
          width: 80,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "性别",
          dataIndex: "SEX_NAME",
          key: "SEX_NAME",
          align: "center",
          width: 80,
          isShow: true,
        },
        {
          title: "年龄",
          dataIndex: "AgeDisPlay",
          key: "AgeDisPlay",
          align: "center",
          width: 60,
          isShow: true,
        },
        {
          title: "出生日期",
          dataIndex: "BIRTHDAY",
          key: "BIRTHDAY",
          align: "center",
          width: 110,
          isShow: true,
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD")}</span>,
        },
        {
          title: "身份证号",
          dataIndex: "ID_NUMBER",
          key: "ID_NUMBER",
          align: "center",
          width: 150,
          isShow: true,
        },

        {
          title: "测量值(mmHg)",
          dataIndex: "SYSTOLIC_PRESSURE",
          key: "SYSTOLIC_PRESSURE",
          align: "center",
          width: 120,
          isShow: true,
          render: (val, values) => {
            return val ? val + "/" + values.DIASTOLIC_PRESSURE : "";
          },
        },
        {
          title: "脉率(bpm)",
          dataIndex: "PULSE_RATE",
          key: "PULSE_RATE",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "检查项目",
          dataIndex: "ITEM_NAME",
          key: "ITEM_NAME",
          align: "center",
          width: 120,
          isShow: true,
        },
        {
          title: "检查时间",
          dataIndex: "EXAM_DATETIME",
          key: "EXAM_DATETIME",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.EXAM_DATETIME).getTime() - new Date(b.EXAM_DATETIME).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },
        {
          title: "创建时间",
          dataIndex: "CREATE_DATE",
          key: "CREATE_DATE",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.CREATE_DATE).getTime() - new Date(b.CREATE_DATE).getTime(),
          render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>,
        },
        {
          title: "家庭住址",
          dataIndex: "HOME_ADDRESS",
          key: "HOME_ADDRESS",
          align: "center",
          width: 220,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            );
          },
        },
        {
          title: "设备ID",
          dataIndex: "DEVICE_NO",
          key: "DEVICE_NO",
          align: "center",
          width: 130,
          isShow: true,
        },
      ],
      criticalVisible: false,
      deepSeekModalVisible: false,
      deepSeekModalPatientPart: {},
      tabsloading: true,//Spin组件，如果没设置spinning属性，则默认为加载状态
    };
  }

  getDeepSeek = async (record, type) => {
    //0解读；1建议
    this.setState({
      deepSeekModalVisible: true,
      deepSeekModalPatientPart: record,
      deepSeekModalType: type,
    });
  };

  //断点续传
  keepAlive = () => {
    let params = {
      TYPE: "HOLTER",
      PARAM: "GET_FILE_STATES",
    };
    let paramsEcho = {
      TYPE: "CONFIGURA",
      PARAM: "GET_CONFIGURATION",
    };
    sendMessage(params);
    sendMessage(paramsEcho); //获取配置信息
    receiveMessage((data) => {
      if (data) {
        if (data.RETURN_VALUE === "GET_CONFIGURATION") {
          //获取心电图机配置信息
          let list = JSON.parse(data.RETURN_MSG);
          this.setState(
            {
              equipmentType: list.machineType ? list.machineType : "",
            },
            () => {
              localStorage.setItem("equipmentType", list.machineType ? list.machineType : "");
            }
          );
        } else {
          if (data.RETURN_VALUE === "文件状态") {
            let arr = getFileStatus(data);
            this.setState({
              loadingList: arr,
            });
          } else {
            if (data.EXAM_UID !== "") {
              this.getTransferStatus(data);
              if (data.RETURN_MSG === "上传成功") {
                message.success("申请会诊成功！");
                this.ApplyQueryTable.searchListFn();
              }
            }
          }
        }
      }
    });
  };

  async componentDidMount() {
    this.getCommonColumnInfo();
    this.getElectroencephalogramCommonColumn();
    this.getTranquillizationBloodColumn();
    await initWebSocket();
    this.keepAlive();
    // 表格设置相关
  }

  getCommonColumnInfo = (newTabData) => {
    //获取、更新表头设置
    newTabData = newTabData || JSON.parse(localStorage.getItem("applyTabSetting")) || this.state.initCommonColumn;
    let commonColumn = getCommonColumnInfoFn(this.state.initCommonColumn, newTabData, "applyTabSetting");
    this.setState({
      commonColumn,
    });
  };
  getElectroencephalogramCommonColumn = (newTabData) => {
    newTabData =
      newTabData ||
      JSON.parse(localStorage.getItem("electroencephalogramTabSetting")) ||
      this.state.initElectroencephalogramCommonColumn;
    let electroencephalogramCommonColumn = getCommonColumnInfoFn(
      this.state.initElectroencephalogramCommonColumn,
      newTabData,
      "electroencephalogramTabSetting"
    );
    this.setState({
      electroencephalogramCommonColumn,
    });
  };
  getTranquillizationBloodColumn = (newTabData) => {
    newTabData =
      newTabData ||
      JSON.parse(localStorage.getItem("tranquillizationBloodColumn")) ||
      this.state.initTranquillizationBloodColumn;
    let commonColumn = getCommonColumnInfoFn(
      this.state.initTranquillizationBloodColumn,
      newTabData,
      "tranquillizationBloodColumn"
    );
    this.setState({
      tranquillizationBloodColumn: commonColumn,
    });
  };
  handleAddPatient = (type) => {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (!userInfo) return;
    let id = userInfo.HOSPITAL_UID;
    getExamItem(id).then((res) => {
      if (res && res.Status === 1) {
        if (!res.Result) return message.error("请联系管理员设置检查项目");
        if (type === "EASY") {
          let hasECG = res.Result.some((i) => i.id === "ECG");
          if (!hasECG) return message.error("请联系管理员设置检查项目");
        }
        this.setState({
          isModalVisible: true,
          title: type === "EASY" ? "快速心电" : "新建患者",
          clickStatus: type || "ADD",
          rowData: "",
          rowsData: [],
          selectedRowKeys: [],
        });
      } else {
        requestErrorLog("", "打开新建/编辑框检查类型级联接口报错", 0, true);
      }
    });

    // 新增
  };

  handleEditPatient = () => {
    // 编辑
    const { selectedRowKeys, rowsData } = this.state;
    const custService = JSON.parse(localStorage.getItem("QUERY_ALL"));
    if (selectedRowKeys.length === 0) {
      Modal.info({ content: "请在列表中选择要编辑的病例信息！" });
    } else if (selectedRowKeys.length === 1) {
      if (!this.canOperation(rowsData)) {
        return;
      }
      if (custService !== 1 && this.judgeEditState(rowsData[0])) {
        //已审核的病例不允许修改
        return;
      } else {
        this.setState({
          isModalVisible: true,
          title: "编辑患者",
          clickStatus: "EDIT", //服务器心电图机数据编辑相当于新建
        });
      }
    } else {
      Modal.info({ content: "请选择一条病例进行编辑" });
    }
  };

  handleDelPatient = () => {
    // 删除
    const { rowsData, selectedRowKeys } = this.state;
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    if (rowsData.length < 1) {
      message.warning("请先选择要删除的报告！");
      return;
    }
    if (rowsData.find((item) => item.CONSULTATION_STATUS !== "未申请")) {
      message.warning("申请会诊病例无法删除！");
      return;
    }
    if (!this.canOperation(rowsData)) return;
    let arraylist = [];
    rowsData.map((item) => {
      return arraylist.push(Object.assign(item, { DELETE_USER_UID: userInfo.USER_UID }));
    });
    confirm({
      title: "删除报告",
      content: "确认删除该报告吗？",
      okText: "确认",
      cancelText: "取消",
      onOk: () => {
        deleteReport(arraylist).then((res) => {
          if (res && res.Status === 1) {
            message.success("已删除报告！");
            this.ApplyQueryTable.searchListFn();
            this.setState({
              selectedRowKeys: [],
              rowsData: [],
              rowData: {},
            });
          } else {
            requestErrorLog(selectedRowKeys.toString(), "远程申请删除报告接口报错", 0, true);
            message.error("报告删除失败！");
          }
        });
      },
    });
  };

  deleteWaitImproved = () => {
    //待完善列表删除患者
    const { rowsData, queryTableData, selectedRowKeys } = this.state;
    var fileUidList = [];
    if (rowsData.length < 1) {
      message.warning("请先选择要删除的报告！");
      return;
    }
    if (rowsData.find((item) => item.CONSULTATION_STATUS !== "未申请")) {
      message.warning("申请会诊病例无法删除！");
      return;
    }
    for (let i = 0; i < queryTableData.length; i++) {
      for (let s = 0; s < rowsData.length; s++) {
        if (queryTableData[i].EXAM_UID === rowsData[s].EXAM_UID) {
          fileUidList.push(queryTableData[i].FILE_UID);
        }
      }
    }
    confirm({
      title: "删除报告",
      content: "确认删除该报告吗？",
      okText: "确认",
      cancelText: "取消",
      onOk: () => {
        deleteWaitImproved(fileUidList).then((res) => {
          if (res && res.Status === 1) {
            message.success("已删除报告！");
            this.ApplyQueryTable.searchListFn();
            this.setState({
              selectedRowKeys: [],
              rowsData: [],
              rowData: {},
            });
          } else {
            requestErrorLog(selectedRowKeys.toString(), "待完善列表删除报告接口报错", 0, true);
            message.error("报告删除失败！");
          }
        });
      },
    });
  };

  handleUrging = () => {
    // 催办
    const { rowsData, selectedRowKeys } = this.state;
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    if (rowsData.length === 0) {
      message.warning("请在列表中选择要操作的病例信息！");
    } else {
      if (!this.canOperation(rowsData)) {
        return;
      }
      if (rowsData.find((item) => item.CONSULTATION_STATUS === "未申请")) {
        Modal.info({ content: "还未申请会诊，不能催办" });
      } else if (rowsData.find((item) => item.CONSULTATION_STATUS === "已会诊")) {
        Modal.info({ content: "已完成会诊，不能催办" });
      } else {
        let resultdata = rowsData.map((item) => ({
          HOSPITAL_CODE: "", //医院code
          DEPT_CODE: "", //科室code不需要传
          USER_UID: userInfo.USER_UID,
          MSG_CODE: "3", //有会诊到达的消息
          MSG_DETAILED: "有【" + userInfo.HOSPITAL_NAME + "】的患者【" + item.NAME + "】催办！",
          EVENT_ID: item.EXAM_UID,
        }));
        let Param = {
          Type: "Urging",
          HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        };
        urging(Param, resultdata).then((res) => {
          if (res && res.Status === 1) {
            message.info("已催办！ ");
          } else {
            requestErrorLog(selectedRowKeys.toString(), "远程申请催办接口报错", 0, true);
          }
        });
      }
    }
  };

  handleCollection = () => {
    // 收藏
    const { rowsData } = this.state;
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    if (rowsData.length === 0) {
      message.warning("请选择要收藏的病例信息！");
    } else if (rowsData.length === 1) {
      if (!this.canOperation(rowsData)) {
        return;
      }
      if (rowsData[0].EXAM_STATUS_NAME === "已审核") {
        let newCOLLECTOR = rowsData[0].COLLECTOR === null ? "" : rowsData[0].COLLECTOR.trim();
        if (newCOLLECTOR.indexOf(userInfo.USER_UID) > -1) {
          message.warning("病例已收藏！");
        } else {
          this.setState({
            bookmarkVisible: true,
          });
        }
      } else {
        message.warning("请选择已审核的病例进行收藏");
      }
    } else {
      message.warning("病例只能单条收藏");
    }
  };

  handleStartReporting = () => {
    // 开始报告
    const { rowsData, rowData } = this.state;
    if (Object.keys(rowData).length === 0) {
      Modal.info({ content: "请在列表中选择要报告的病例信息！" });
      return;
    } else if (rowsData.length === 1) {
      if (rowData.EXAM_STATUS_NAME === "解析中") {
        return message.error("数据正在解析，请稍后查看");
      }
      if (rowData.EXAM_STATUS_NAME === "解析失败") {
        return message.error("解析失败，无法查看");
      }

      if (
        rowData.CONSULTATION_STATUS === "未会诊" ||
        rowData.CONSULTATION_STATUS === "会诊中" ||
        rowData.CONSULTATION_STATUS === "撤销中"
      ) {
        //未会诊和会诊中的病例不能查看
        Modal.info({ content: "病例正在会诊中，无法查看" });
        return;
      }
      if (parseInt(this.state.showKey) === 3) {
        if (rowData.EXAM_STATUS_NAME === "未检查") {
          Modal.info({ content: "请先完成录入" });
          return;
        }
        this.dynamicBloodClicks();
        return;
      } else if (parseInt(this.state.showKey) === 1) {
        if (rowData.EXAM_STATUS_NAME === "未检查") {
          Modal.info({ content: "请先完成检查" });
          return;
        }
      }
      if (rowData.EXAM_STATUS_NAME === "未检查" && rowData.CONSULTATION_STATUS === "未申请") {
        Modal.info({ content: "请先完成检查" });
      } else if (rowData.EXAM_STATUS_NAME === "已审核" && rowData.CONSULTATION_STATUS === "已会诊") {
        this.setState(
          {
            tabsloading: true,
          },
          this.paitentRefData(2)
        );
      } else {
        this.setState(
          {
            tabsloading: true,
          },
          this.paitentRefData()
        );
      }
    } else {
      Modal.info({ content: "请选择一条病例进行报告" });
      return;
    }
  };

  getExamImage = (EXAM_UID) => {
    // 诊断图像pdf
    printPic(EXAM_UID).then((res) => {
      if (res && res.Status === 1) {
        const picUrl = window.g.baseURL + "/" + res.Result;
        window.open(picUrl); // 打开pdf文件
      } else {
        requestErrorLog(EXAM_UID, "远程申请打开PDF接口报错", 0, true);
        message.error("请求失败");
      }
    });
  };

  handleApply = (record, e) => {
    // 单击申请会诊
    e.preventDefault();
    e.stopPropagation();
    const rolePrivilege = JSON.parse(localStorage.getItem("roleList"));
    if (rolePrivilege.indexOf("申请会诊") > -1) {
      this.setState(
        {
          selectedRows: [],
          selectedRowKeys: [record.EXAM_UID],
          rowsData: [record],
        },
        () => this.handleSubmitApply()
      );
    } else {
      message.error("暂无权限，请联系管理员");
    }
  };

  handleSubmitApply = async () => {
    // 申请会诊
    const { rowsData, selectedRowKeys } = this.state;
    if (rowsData.length === 0) {
      Modal.info({ content: "请在列表中选择要会诊的病例信息！" });
    } else {
      let immediateData = []; //病例实时状态
      let s = selectedRowKeys.toLocaleString();
      let isContinue = true;
      if (s !== "") {
        let params = {
          Type: "GetPatientList", // 患者信息
          EXAM_UID: s,
        };
        await cancelCollect(params).then((res) => {
          if (res && res.Status === 1) {
            immediateData = res.Result;
            for (let i = 0; i < immediateData.length; i++) {
              if (this.judgeApplyState(immediateData[i])) {
                this.refreshTable();
                isContinue = false;
                return;
              }
            }
          } else {
            requestErrorLog(selectedRowKeys.toString(), "远程申请患者信息接口报错", 0, true);
          }
        });
        if (!isContinue) {
          return;
        }
      }
      if (!this.canOperation(rowsData)) {
        //传输过程中不允许申请会诊
        return;
      }
      this.setState({
        applyVisible: true,
        applyConsulationType: "apply",
        applyType: "ApplyADD",
      });
    }
  };

  judgeApplyState = (data) => {
    //判断是否可以申请会诊
    if (data.EXAM_STATUS_NAME === "解析中") {
      message.error("数据正在解析，暂无法申请");
      return true;
    }
    if (data.EXAM_STATUS_NAME === "解析失败") {
      message.error("解析失败，无法申请");
      return true;
    }
    if (
      data.EXAM_STATUS_NAME === "未报告" &&
      (data.CONSULTATION_STATUS === "会诊中" || data.CONSULTATION_STATUS === "未会诊")
    ) {
      Modal.info({ content: "已发送过此会诊医院，不允许重复申请" });
      return true;
    } else if (data.EXAM_STATUS_NAME === "未检查" && data.CONSULTATION_STATUS === "未申请") {
      Modal.info({ content: "未检查，不能申请会诊" });
      return true;
    } else if (data.EXAM_STATUS_NAME === "已审核" && data.CONSULTATION_STATUS === "已会诊") {
      Modal.info({ content: "会诊已完成不能重复申请" });
      return true;
    } else if (
      data.EXAM_STATUS_NAME === "已审核" &&
      (data.CONSULTATION_STATUS === "会诊中" ||
        data.CONSULTATION_STATUS === "未会诊" ||
        data.CONSULTATION_STATUS === "撤销中")
    ) {
      Modal.info({ content: "已发送过此会诊医院，不允许重复申请" });
      return true;
    } else if (
      data.EXAM_STATUS_NAME === "已报告" &&
      (data.CONSULTATION_STATUS === "会诊中" ||
        data.CONSULTATION_STATUS === "未会诊" ||
        data.CONSULTATION_STATUS === "撤销中")
    ) {
      Modal.info({ content: "已发送过此会诊医院，不允许重复申请" });
      return true;
    } else {
      return false;
    }
  };

  judgeEditState = (data) => {
    //判断是否可以编辑患者
    if (data.EXAM_STATUS_NAME === "已审核") {
      Modal.info({ content: "该病例已审核，不允许进行编辑" });
      return true;
    } else if (
      data.EXAM_STATUS_NAME === "未报告" &&
      (data.CONSULTATION_STATUS === "会诊中" || data.CONSULTATION_STATUS === "未会诊")
    ) {
      Modal.info({ content: "会诊中，不允许进行编辑" });
      return true;
    } else if (
      data.EXAM_STATUS_NAME === "已报告" &&
      (data.CONSULTATION_STATUS === "会诊中" || data.CONSULTATION_STATUS === "未会诊")
    ) {
      Modal.info({ content: "会诊中，不允许进行编辑" });
      return true;
    } else {
      return false;
    }
  };

  handleCancelApply = () => {
    // 取消会诊
    const { rowsData, selectedRowKeys } = this.state;
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    if (rowsData.length === 0) {
      message.info("请在列表中选择要取消会诊的病例信息！");
    } else {
      if (!this.canOperation(rowsData)) {
        return;
      }
      if (rowsData.find((item) => item.CONSULTATION_STATUS === "未申请")) {
        Modal.info({ content: "未申请远程，不能取消会诊" });
        this.refreshTable();
        return;
      } else if (rowsData.find((item) => item.CONSULTATION_STATUS === "会诊中")) {
        Modal.info({ content: "会诊中，不能取消会诊" });
        this.refreshTable();
        return;
      } else if (rowsData.find((item) => item.CONSULTATION_STATUS === "已会诊")) {
        Modal.info({ content: "会诊已完成，不能取消会诊" });
        this.refreshTable();
        return;
      } else if (rowsData.find((item) => item.CONSULTATION_STATUS === "撤销中")) {
        Modal.info({ content: "撤销中，不能取消会诊" });
        this.refreshTable();
        return;
      } else {
        // 2025年3月13日修改 新建患者申请医生跟申请会诊医生(当前登录医生)分开
        if (rowsData.find((item) => item.APPLY_DOCTOR_CODE !== userInfo.USER_UID)) {
          Modal.info({
            content: "选择病例包含其他用户已申请数据，无权限取消！",
          });
          this.refreshTable();
          return;
        }
        Modal.confirm({
          title: "提示",
          content: "确认取消会诊吗？",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            let newRowsData = JSON.stringify(rowsData); //需要把USER_UID塞进RequestModel内，不改变原有的rowsdata
            newRowsData = JSON.parse(newRowsData);
            newRowsData = newRowsData.map((item) => {
              item.APPLY_DOCTOR_CODE = userInfo.USER_UID;
              return item;
            });
            canceAppointment(newRowsData).then((res) => {
              if (res && res.Status === 1) {
                switch (res.Result) {
                  case -2:
                    message.warning("存在多级会诊，不能取消会诊");
                    this.refreshTable();
                    return;
                  case -3:
                    message.warning("会诊中，不能取消会诊");
                    this.refreshTable();
                    return;
                  case -6:
                    message.warning("未申请，不能取消会诊");
                    this.refreshTable();
                    return;
                  case -4:
                    message.warning("已会诊，不能取消会诊");
                    this.refreshTable();
                    return;
                  case -5:
                    message.warning("会诊医院不存在，不能取消会诊");
                    this.refreshTable();
                    return;
                  default:
                    break;
                }
                this.refreshTable();
                message.success("成功取消会诊！");
              } else {
                message.error("取消会诊失败！");
                requestErrorLog(selectedRowKeys.toString(), "远程申请取消会诊接口报错", 0, true);
                this.refreshTable();
              }
            });
          },
        });
      }
    }
  };

  handleTabKey = (key) => {
    // 切换tabs
    this.props.history.push("/siderPage?key=2&applyTabskey=" + key);
    this.setState({
      showKey: key,
      PageNo: 1,
      PageSize: 10,
      tabsloading: true,
      rowsData: [],
      rowData: {},
      selectedRowKeys: [],
    });
  };

  onClickRow = (record) => {
    // 单击行事件
    let arraylist = [];
    arraylist.push(record.EXAM_UID);
    let rowsData = [];
    rowsData.push(record);
    this.setState({
      selectedRowKeys: arraylist,
      rowData: record,
      rowsData: rowsData,
      bookmarkdetail: record.COLLECT_TAG ? record.COLLECT_TAG : "",
      submitType: "add",
      isEdit: record.COLLECT_TAG ? true : false,
    });
  };

  initEditExam = (id) => {
    console.log(id, "id");
    // 开始检查更新检查状态
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    var dataTime = new Date();
    var dateTime = moment(dataTime).format("YYYY-MM-DD HH:mm:ss");
    let params = {
      EXAM_UID: id, // 检查唯一uid
      EXAM_STATUS: 1, // 检查状态（未报告1）
      EXAM_DOCTOR_UID: userInfo.USER_UID, // 检查人唯一uid
      EXAM_DOCTOR_NAME: userInfo.REAL_NAME, // 检查人
      EXAM_DATETIME: dateTime, // 检查时间
    };
    checkExam(params).then((res) => {
      if (res && res.Status === 1) {
        // this.refreshTable();
        this.ApplyQueryTable.searchListFn();
      } else {
        message.error("检查信息编辑失败！");
        requestErrorLog(id, "远程申请患者检查接口报错", 0, true);
      }
    });
  };

  paitentRefData = (privilecg, values, value) => {
    const { rowData } = this.state;
    const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || {};
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    const settingData = JSON.parse(localStorage.getItem("settingValues")) || {};
    if (!rowData && !values) {
      return this.setState({ tabsloading: false });
    }
    let patientPrivilege = this.getRolePrivilegeFn();
    let statusData = {
      EXAM_UID: rowData.EXAM_UID || privilecg.EXAM_UID, // 患者的唯一id
      NAME: rowData.NAME || values.NAME, // 姓名
      SERVER: window.g.baseURL, // 可配置的服务器地址
      USER_INFO: userInfo, // 登录人的用户信息
      CA_ENABLED: window.g.CA,
      PRIVILEGE: typeof privilecg !== "number" ? patientPrivilege : privilecg, //权限   报告：0  审核：1  查看：2  采集:3
      PRINT_HOSPITAL: settingData.printingType, // 打印医院
      PRINT_SIGN_TYPE: settingData.signatureType, // 签名类型
    };
    let params;
    //保存并检查 静息心电ECG、动态心电Holter、脑电EEG
    if (value === "inspect") {
      params = {
        TYPE: values.EXAM_CLASS === "ECG" ? "ECG" : values.EXAM_CLASS === "Holter" ? "HOLTER" : "EEG",
        PARAM:
          values.EXAM_CLASS === "ECG"
            ? "STAR_COLLECTION"
            : values.EXAM_CLASS === "Holter"
            ? "START_MONITOR"
            : "START_EEG_MONITOR", //开始采集
        ...statusData,
        COLLECTION_PRIVILEGE: values.EXAM_CLASS !== "EEG" ? (rolePrivilege.indexOf("采集") > -1 ? 1 : 0) : "", //静息心电增加采集权限
      };
      this.handleHolterSeverMsg(params);
    }
    if (rowData) {
      if (rowData.EXAM_STATUS_NAME === "未检查") {
        params = {
          TYPE: rowData.EXAM_CLASS === "ECG" ? "ECG" : rowData.EXAM_CLASS === "Holter" ? "HOLTER" : "EEG",
          PARAM:
            rowData.EXAM_CLASS === "ECG"
              ? "STAR_COLLECTION"
              : rowData.EXAM_CLASS === "Holter"
              ? "START_MONITOR"
              : "START_EEG_MONITOR",
          ...statusData,
          COLLECTION_PRIVILEGE: rowData.EXAM_CLASS !== "EEG" ? (rolePrivilege.indexOf("采集") > -1 ? 1 : 0) : "", //静息心电增加采集权限
        };
        this.handleHolterSeverMsg(params);
      }
      if (rowData.EXAM_STATUS_NAME !== "未检查") {
        params = {
          PARAM:
            rowData.EXAM_CLASS === "ECG"
              ? "OUR_HOSPITAL"
              : rowData.EXAM_CLASS === "Holter"
              ? "OUR_HOSPITAL"
              : "START_EEG_MONITOR", //开始报告
          TYPE: rowData.EXAM_CLASS === "ECG" ? "ECG" : rowData.EXAM_CLASS === "Holter" ? "HOLTER" : "EEG",
          ...statusData,
        };
        this.handleHolterSeverMsg(params);
      }
    }
  };

  // websocket
  handleHolterSeverMsg = (params) => {
    const { rowData } = this.state;
    // const roleListdata = JSON.parse(localStorage.getItem("roleList")) || {};
    if (!this.canOperation([rowData])) {
      return;
    }
    sendMessage(params);
    receiveMessage((data) => {
      console.log(data, "走监控的");
      if (data.RETURN_MSG) {
        this.setState({
          tabsloading: false,
          addStatus: data.TYPE,
          holterData: data.EXAM_UID ? data.RETURN_MSG : "",
        });
      }

      if (data.EXAM_UID && data.RETURN_VALUE !== "RV_SUC_PROGRAM_EXIT" && data.RETURN_VALUE !== "RV_SUC_REPORT") {
        this.getTransferStatus(data);
      }

      if (data.RETURN_VALUE === "RV_SUC_PROGRAM_EXIT" || data.RETURN_VALUE === "RV_SUC_REPORT") {
        this.setState({
          checkVisible: false,
          holterData: "",
        });
        this.ApplyQueryTable.searchListFn();
      }
      if (data.RETURN_MSG === "拷贝成功" || (data.RETURN_MSG === "上传成功" && data.TYPE === "EEG")) {
        this.setState({
          holterData: "",
          checkVisible: false,
        });
        this.ApplyQueryTable.searchListFn();
      }
      if (data.RETURN_MSG === "拷贝成功" || (data.RETURN_MSG === "上传成功" && data.TYPE === "ECG")) {
        this.setState({
          holterData: "",
          checkVisible: false,
          applyType: "ApplyADD",
        });
        this.initEditExam(data.EXAM_UID);
        this.ApplyQueryTable.searchListFn();
        this.ApplyConsulation.handleApplyConsult(params);
      }
      if (data.RETURN_MSG === "上传成功" && data.TYPE === "HOLTER") {
        this.ApplyQueryTable.searchListFn();
      }
    });
  };

  canOperation = (data) => {
    let loadingList = this.state.loadingList;
    let status = true;
    data.forEach((elem) => {
      loadingList.forEach((item) => {
        if (item.EXAM_UID === elem.EXAM_UID) {
          status = fileStatus(item.RETURN_MSG);
        }
      });
    });
    if (!status) {
      message.error("该病例正在传输中，无法执行此操作");
      return false;
    } else {
      return true;
    }
  };

  //动态血压的双击事件
  dynamicBloodClicks = () => {
    const { rowData } = this.state;
    if (Object.keys(rowData).length > 0) {
      if (rowData.EXAM_STATUS_NAME === "未检查") {
        message.info("动态血压数据导入请选择提取血压信息");
      } else {
        this.bloodReport(rowData);
      }
    }
  };

  //动态血压报告
  bloodReport = (rowData) => {
    this.setState({
      tabsloading: true,
    });
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    const settingData = JSON.parse(localStorage.getItem("settingValues")) || {};
    const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || {};
    if (rowData.EXAM_STATUS_NAME === "已审核" && rowData.CONSULTATION_STATUS === "未申请") {
      if (rolePrivilege.indexOf("查看报告") > -1) {
        this.setState({
          tabsloading: false,
        });
      } else {
        this.setState({
          tabsloading: false,
        });
        this.getExamImage(rowData.EXAM_UID);
        return;
      }
    }
    let PRIVILEGE = this.getRolePrivilegeFn();
    if (rowData.EXAM_STATUS_NAME === "已审核" && rowData.CONSULTATION_STATUS === "已会诊") {
      if (PRIVILEGE === 5) {
        this.getExamImage(rowData.EXAM_UID);
        this.setState({
          tabsloading: false,
        });
        return;
      }
      PRIVILEGE = 2;
    } else {
      this.setState({
        tabsloading: false,
      });
    }
    if (typeof PRIVILEGE === "number") {
      let params = {
        TYPE: "BLOOD",
        PARAM: "OUR_HOSPITAL",
        EXAM_UID: rowData.EXAM_UID,
        NAME: rowData.NAME,
        SERVER: window.g.baseURL,
        CA_ENABLED: window.g.CA,
        PRIVILEGE,
        USER_INFO: userInfo,
        PRINT_HOSPITAL: settingData.printingType, // 打印医院
        PRINT_SIGN_TYPE: settingData.signatureType, // 签名类型
      };
      sendMessage(params);

      receiveMessage((data) => {
        this.setState({
          tabsloading: false,
        });
        if (data.RETURN_VALUE === "RV_SUC_PROGRAM_EXIT" || data.RETURN_VALUE === "RV_SUC_REPORT") {
          this.ApplyQueryTable.searchListFn();
        }
      });
    }
  };

  getRolePrivilegeFn = () => {
    const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || {};
    let PRIVILEGE;
    if (rolePrivilege.indexOf("审核报告") > -1 && rolePrivilege.indexOf("提交报告") > -1) {
      PRIVILEGE = 3;
    } else if (rolePrivilege.indexOf("审核报告") > -1) {
      PRIVILEGE = 1;
    } else if (rolePrivilege.indexOf("提交报告") > -1) {
      PRIVILEGE = 0;
    } else if (rolePrivilege.indexOf("查看报告") > -1) {
      PRIVILEGE = 2;
    } else if (rolePrivilege.indexOf("采集") > -1) {
      PRIVILEGE = 4;
    } else if (rolePrivilege.indexOf("PDF查看") > -1) {
      PRIVILEGE = 5;
    } else {
      message.error("暂无权限，请联系管理员");
      return false;
    }
    return PRIVILEGE;
  };

  handleDoubleClicks = () => {
    // 双击事件
    const { rowData } = this.state;
    const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || {};
    const custService = JSON.parse(localStorage.getItem("QUERY_ALL"));
    if (custService === 1) {
      return;
    } //客服权限无法操作病例
    if (rowData.EXAM_STATUS_NAME === "解析中") {
      return message.error("数据正在解析，请稍后查看");
    }
    if (rowData.EXAM_STATUS_NAME === "解析失败") {
      return message.error("解析失败，无法查看");
    }
    //双击待完善列表-编辑
    if (parseInt(this.state.showKey) === 4) {
      return this.handleEditPatient();
    }
    //脑电地形图
    if (parseInt(this.state.showKey) === 5) {
      if (JSON.stringify(rowData) === JSON.stringify({})) {
        return;
      }
      if (rowData.EXAM_STATUS_NAME === "未检查" && rowData.EXAM_CLASS === "EEG") {
        this.setState(
          {
            checkVisible: true, // 开始检查
          },
          () => this.paitentRefData()
        );
      } else {
        this.getExamImage(rowData.EXAM_UID); // 诊断图像pdf
      }
    } else {
      //撤销中的病例双击优先打开
      if (rowData.CONSULTATION_STATUS === "撤销中") {
        this.setState({
          revokeVisible: true,
        });
        return;
      }
      //会诊中和未会诊的病例不能查看
      if (rowData.CONSULTATION_STATUS === "未会诊" || rowData.CONSULTATION_STATUS === "会诊中") {
        return Modal.info({ content: "病例正在会诊中，无法查看" });
      }
      if (JSON.stringify(rowData) === JSON.stringify({})) {
        return;
      } else {
        //血压走的逻辑
        if (rowData.EXAM_STATUS_NAME === "未检查" && rowData.EXAM_CLASS === "BloodPressure") {
          this.dynamicBloodClicks();
          return;
        }
        //静息心电、动态血压走的逻辑
        if (rowData.EXAM_STATUS_NAME === "未检查") {
          if (rolePrivilege.indexOf("采集") > -1) {
            this.setState(
              {
                checkVisible: true, // 开始检查
                addStatus: rowData.EXAM_CLASS, //检查类型
              },
              () => this.paitentRefData()
            );
          } else {
            message.error("暂无权限，请联系管理员");
            return;
          }
        } else if (rowData.EXAM_STATUS_NAME === "已审核" && rowData.CONSULTATION_STATUS === "已会诊") {

            //新加逻辑
            if (parseInt(this.state.showKey) === 3) {
              this.dynamicBloodClicks();
            } else {
              this.setState(
                {
                  tabsloading: true,
                },
                () => this.paitentRefData(2)
              );
          } 
        } else if (rowData.EXAM_STATUS_NAME === "已审核" && rowData.EXAM_CLASS === "ECG") {
          if (this.getRolePrivilegeFn() <= 3) {
            this.setState(
              {
                tabsloading: true,
              },
              () => this.paitentRefData()
            );
          } else {
            this.getExamImage(rowData.EXAM_UID); // 诊断图像pdf
          }
        } else {
          if (parseInt(this.state.showKey) === 3) {
            this.dynamicBloodClicks();
          } else {
            let privilecg = this.getRolePrivilegeFn();
            if (typeof privilecg === "number") {
              this.setState(
                {
                  tabsloading: true,
                },
                this.paitentRefData(privilecg)
              );
            }
          }
        }
      }
    }
  };

  setRowClassName = (record) => {
    if (record.DANGER_FLAG === 1) {
      return "danger-row";
    } else if (record === this.state.rowData) {
      return "clickRowStyl";
    } else {
      return "";
    }
  };

  getData = (tableData, count, PageNo, PageSize, tabsloading) => {
    // 获取子组件数据
    this.setState({
      queryTableData: tableData,
      RowCount: count,
      PageNo,
      PageSize,
      tabsloading,
    });
  };

  getApplyCount = (count) => {
    // 获取气泡值
    this.setState({
      applyCount: count,
    });
  };

  getTransferStatus = (value) => {
    // 接收子组件报告状态
    let loadingList = this.state.loadingList;
    if (loadingList.some((item) => item.EXAM_UID === value.EXAM_UID)) {
      loadingList.forEach((item, index) => {
        if (item.EXAM_UID === value.EXAM_UID) {
          loadingList.splice(index, 1, value);
        }
      });
    } else {
      loadingList.push(value);
    }
    this.setState({
      loadingList,
      tabsloading: false,
    });
  };

  onSelectChange = (selectedRowKeys) => {
    //勾选选框事件触发
    if (selectedRowKeys.length === 1) {
      let s = "";
      s = selectedRowKeys.toLocaleString();
      if (s !== "") {
        let params = {
          Type: "GetPatientList", // 患者信息
          EXAM_UID: s,
        };
        cancelCollect(params).then((res) => {
          if (res && res.Status === 1) {
            this.setState({
              rowsData: res.Result,
              rowData: res.Result[0],
              selectedRowKeys: selectedRowKeys,
              bookmarkdetail: res.Result[0].COLLECT_TAG ? res.Result[0].COLLECT_TAG : "",
              submitType: "add",
              isEdit: res.Result[0].COLLECT_TAG ? true : false,
            });
          }
        });
      }
    } else if (selectedRowKeys.length === 0) {
      this.setState({
        rowsData: [],
        rowData: {},
        tabsloading: false,
        selectedRowKeys: [],
        bookmarkdetail: "",
        submitType: "",
        isEdit: true,
      });
    } else {
      let s = "";
      s = selectedRowKeys.toLocaleString();
      if (s !== "") {
        let params = {
          Type: "GetPatientList", // 患者信息
          EXAM_UID: s,
        };
        cancelCollect(params).then((res) => {
          if (res && res.Status === 1) {
            this.setState({
              rowsData: res.Result,
              bookmarkdetail: "",
              submitType: "",
              isEdit: true,
            });
          }
        });
      }
    }
    this.setState({
      selectedRowKeys,
    });
  };

  handleStartCheck = () => {
    // 开始检查
    const rolePrivilege = JSON.parse(localStorage.getItem("roleList"));
    const { rowData, rowsData } = this.state;
    if (rowsData.length === 0) {
      message.warning("请在列表中选择要检查的病例信息！");
    } else if (rowsData.length === 1) {
      if (rowsData[0].EXAM_STATUS_NAME !== "未检查") {
        message.warn("请选择未检查的数据进行检查");
        return;
      }
      if (!this.canOperation([rowData])) {
        return;
      } else {
        if (rolePrivilege.indexOf("采集") > -1) {
          this.setState(
            {
              checkVisible: true,
            },
            () => this.paitentRefData()
          );
        } else {
          message.error("暂无权限，请联系管理员");
        }
      }
    } else {
      Modal.info({ content: "请选择一条病例进行检查" });
    }
  };

  //每次切换页码的时候,更新之前初始化的页码
  onChangePage = (page, PageSize) => {
    this.setState({
      PageNo: page,
    });
  };

  refreshTable = () => {
    //刷新列表事件
    this.setState({
      selectedRowKeys: [],
      rowsData: [],
      // rowData: {}
    });
    this.ApplyQueryTable.searchListFn();
  };

  extractBloodInfo = () => {
    //提取血压信息
    this.setState({
      tabsloading: true,
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    if (userInfo.USER_UID) {
      let params = {
        TYPE: "BLOOD",
        PARAM: "GET_BLOOD_INFO",
        SERVER: window.g.baseURL,
        USER_INFO: userInfo,
        CA_ENABLED: window.g.CA,
      };
      sendMessage(params);
      receiveMessage(async (data) => {
        //获取患者信息
        let params = {
          Type: "GetPatientList",
          EXAM_UID: data.EXAM_UID,
        };
        if (data && data.EXAM_UID) {
          this.getTransferStatus(data);
        }
        if (data.RETURN_VALUE === "RV_ERR_NOTEXIST_INFO") {
          message.error(data.RETURN_MSG);
        }
        if (data.RETURN_MSG === "提取血压信息出错，请检查设备连接") {
          message.error("提取血压信息失败，请检查设备连接");
        }
        if (data.RETURN_MSG === "提取成功") {
          message.success("提取成功");
          this.setState({
            applyType: "ApplyADD",
          });
          this.ApplyQueryTable.searchListFn();
          //获取用户信息并修改类型供快速申请会诊使用
          let res = await cancelCollect(params);
          let bloodType = res.Result?.find((item) => {
            return (item.TYPE = "BLOOD");
          });
          this.ApplyConsulation.handleApplyConsult(bloodType);
        }
        this.setState({
          tabsloading: false,
        });
      });
    }
  };

  cancelEcgReport = () => {
    this.setState({
      ecgStartReportBtn: false,
    });
  };

  handleHeader = () => {
    // 点击表头
    this.setState({
      showColumn: true,
    });
  };

  getEcgSeverData = (type, values, isGetEcgData, hisValue) => {
    const { rowData } = this.state;
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    let ecgData = {
      TYPE: "ECG",
      PARAM: "START_MONITOR",
      EXAM_UID: rowData.EXAM_UID || type.EXAM_UID,
      NAME: rowData.NAME || values.NAME,
      SERVER: window.g.baseURL,
    };
    let XMLECGData = {
      TYPE: "ECG", //参考TYPE类型说明
      PARAM: "RECEIV_FILES_SERVER", //参考PARAM参数说明
      SERVER: window.g.baseURL,
      FILE_UID: hisValue,
      EXAM_UID: rowData.EXAM_UID || type.EXAM_UID,
      USER_INFO: userInfo,
    };
    if (parseInt(this.state.equipmentType) > 100 && isGetEcgData === "getEcgData") {
      //如果是光电12导(服务器)-xml并且点了接收心电图机数据按钮
      sendMessage(XMLECGData);
    } else {
      sendMessage(ecgData);
    }
    receiveMessage((received_msg) => {
      console.log(received_msg, "接收到的数据..");
      this.setState({
        checkVisible: true,
        addStatus: "ECG",
        holterData: received_msg.EXAM_UID ? received_msg.RETURN_MSG : "",
      });
      if (received_msg && received_msg.EXAM_UID) {
        this.getTransferStatus(received_msg);
      }
      if (received_msg.RETURN_MSG === "上传成功") {
        setTimeout(() => {
          this.setState({
            checkVisible: false,
            holterData: "",
          });
        }, 300);
        this.initEditExam(received_msg.EXAM_UID);
        this.ApplyQueryTable.searchListFn();
      }
    });
  };

  //静息心电心电图机接收数据
  handleEcgSeverMsg = () => {
    const { rowsData } = this.state;
    if (rowsData.length === 1) {
      if (rowsData[0].EXAM_STATUS_NAME === "未检查" && rowsData[0].CONSULTATION_STATUS === "未申请") {
        this.getEcgSeverData(rowsData);
      } else if (rowsData[0].EXAM_STATUS_NAME === "未报告" && rowsData[0].CONSULTATION_STATUS === "未申请") {
        confirm({
          title: "重做",
          content: "是否需要重做",
          okText: "重做",
          cancelText: "取消",
          onOk: () => {
            this.getEcgSeverData(rowsData);
          },
        });
      } else {
        message.info("该病例无法重复接收数据");
      }
    } else {
      message.info("请选择一条数据接收");
    }
  };

  // 静息心电批量接收数据
  handleBatchEcgSeverMsg = () => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};

    let params = {
      TYPE: "ECG",
      PARAM: "BATCH_RECEIVING",
      SERVER: window.g.baseURL,
      USER_INFO: userInfo,
    };
    sendMessage(params); // 发送的数据
    receiveMessage((serverMsg) => {
      if (serverMsg && serverMsg.EXAM_UID) {
        this.getTransferStatus(serverMsg);
      }
      switch (serverMsg.RETURN_VALUE) {
        case "RV_SUC_RECEIVE":
          let getBatchNum = JSON.parse(serverMsg.RETURN_RATE);
          this.setState({ getBatchNum });
          break;

        case "RV_ERR_BATCH":
          this.setState({ errBatchMsg: serverMsg.RETURN_VALUE });
          break;

        case "RV_ERR_BATCH_TRANS":
          this.setState({ infoBatchMsg: serverMsg.RETURN_VALUE });
          break;

        case "RV_SUC_BATCH_FINISH":
          let getbatchTableList = serverMsg.RETURN_RATE && JSON.parse(serverMsg.RETURN_RATE);
          this.setState({
            sucBatchMsg: serverMsg.RETURN_VALUE,
            getbatchTableList,
          });
          break;

        default:
          break;
      }
    });
    this.setState({
      batchReceiveVisible: true,
    });
  };

  //转诊申请
  handleApplyReferral = () => {
    const { rowsData } = this.state;
    let menuList = JSON.parse(localStorage.getItem("menuList")) || [];
    let loginRealId = localStorage.getItem("loginRealId");
    let isHaveReferral = menuList.indexOf("单向转诊");
    if (isHaveReferral === -1 && loginRealId !== "PLATFORMUSER") {
      message.error("暂无权限，请联系管理员");
      return;
    }
    if (rowsData.length === 1) {
      this.props.history.push("/siderPage?key=8&examId=" + rowsData[0].EXAM_UID);
      window.location.reload();
    } else {
      message.error("请选择一条病例进行操作");
    }
  };

  //导出数据列表
  exportList = () => {
    let obj = {
      index: "",
      name: "",
    };

    let { commonColumn, electroencephalogramCommonColumn, waitColumn, tranquillizationBloodColumn } = this.state;
    let temp = [];
    if (this.state.showKey === "5") {
      temp = electroencephalogramCommonColumn;
    } else if (this.state.showKey === "4") {
      temp = waitColumn;
    } else if (this.state.showKey === "6") {
      temp = tranquillizationBloodColumn;
    } else {
      temp = commonColumn;
    }
    temp.forEach((item) => {
      if (item.key !== "Progress" && item.key !== "view") {
        obj.index += "," + item.key;
        obj.name += "," + item.title;
      }
    });
    obj.index = obj.index.slice(1);
    obj.name = obj.name.slice(1);
    this.ApplyQueryTable.initQueryList(this.state.showKey, true, obj);
  };
  reReceive = () => {
    if (this.state.rowsData.length === 1) {
      // 重新接收按钮不考虑病例状态，直接接收覆盖
      this.setState(
        {
          checkVisible: true,
        },
        () => this.paitentRefData()
      );
    } else {
      message.warn("请选择一条数据接收收");
    }
  };

  handleCriticalCase = () => {
    const { rowsData } = this.state;
    if (rowsData.find((item) => item.EXAM_STATUS_NAME === "已审核")) {
      this.setState({
        criticalVisible: true,
      });
    } else {
      message.warning("请选择已审核的病例！");
    }
  };

  handleCancelCriticalCase = () => {
    const { rowsData } = this.state;
    if (rowsData.find((item) => item.DANGER_FLAG === 1)) {
      confirm({
        title: "取消危急值",
        content: "确定要取消危急值吗？",
        onText: "确认",
        cancelText: "取消",
        onOk: async () => {
          const res = await cancelCriticalCase(this.state.rowData.EXAM_UID);
          if (res && res.Status === 1) {
            message.success("取消危急值成功！");
            this.refreshTable();
          }
        },
      });
    } else {
      message.warning("请选择危急值病例！");
    }
  };
 updateParentLoadingState = (tabsloading, childCallback) => {
    this.setState({
      tabsloading
    }, () => {
      if (childCallback) {
        childCallback();
      }
    })
  }
  render() {
    const {
      commonColumn,
      waitColumn,
      queryTableData,
      tabsloading,
      showKey,
      revokeVisible,
      holterData,
      transmiMsg,
      transmiRate,
      applyCount,
      isModalVisible,
      showColumn,
      applyType,
      title,
      rowData,
      clickStatus,
      checkVisible,
      applyVisible,
      selectedRowKeys,
      rowsData,
      submitType,
      bookmarkVisible,
      bookmarkdetail,
      isEdit,
      batchReceiveVisible,
      applyConsulationType,
      equipmentType,
      electroencephalogramCommonColumn,
      tranquillizationBloodColumn,
    } = this.state;
    const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || [];
    const menuType = JSON.parse(localStorage.getItem("menuList")) || [];
    const settingVal = JSON.parse(localStorage.getItem("settingValues"));
    const custService = JSON.parse(localStorage.getItem("QUERY_ALL")); //客服权限可以删除
    return (
      <div className="applyWrapper">
        {parseInt(this.state.showKey) === 6 ? (
          <div className="tabs_wrap">
            <div onClick={this.exportList}>
              <img src={exportExcel} alt="" style={{ width: "33px", marginLeft: "27px" }}></img>
              <p>导出列表</p>
            </div>
          </div>
        ) : (
          <>
            {custService === 1 || parseInt(this.state.showKey) === 4 ? (
              <div className="tabs_wrap">
                <div onClick={() => this.handleEditPatient(clickStatus)}>
                  <Icon type="edit" className="icon" />
                  <p>编辑患者</p>
                </div>
                {custService === 1 || rolePrivilege.indexOf("删除病历") > -1 ? (
                  custService === 1 ? (
                    <div onClick={this.handleDelPatient}>
                      <Icon type="delete" className="icon" />
                      <p>删除报告</p>
                    </div>
                  ) : (
                    <div onClick={this.deleteWaitImproved}>
                      <Icon type="delete" className="icon" />
                      <p>删除患者</p>
                    </div>
                  )
                ) : null}
              </div>
            ) : (
              <div className="tabs_wrap">
                <div onClick={() => this.handleAddPatient("ADD")}>
                  <Icon type="user-add" className="icon" />
                  <p>新建患者</p>
                </div>
                {parseInt(this.state.showKey) === 1 ? (
                  <div onClick={() => this.handleAddPatient("EASY")}>
                    <img
                      src={easyCreateIcon}
                      alt=""
                      style={{
                        width: "33px",
                        marginLeft: "27px",
                        marginBottom: "4px",
                        marginTop: "3px",
                      }}
                    />
                    <p>快速心电</p>
                  </div>
                ) : null}

                <div onClick={() => this.handleEditPatient(clickStatus)}>
                  <Icon type="edit" className="icon" />
                  <p>编辑患者</p>
                </div>
                {parseInt(this.state.showKey) === 3 ? (
                  <div onClick={this.extractBloodInfo}>
                    <img
                      src={tqxyIcon}
                      alt=""
                      style={{
                        width: "33px",
                        marginLeft: "27px",
                        marginBottom: "4px",
                        marginTop: "3px",
                      }}
                    />
                    <p>提取血压信息</p>
                  </div>
                ) : null}
                {rolePrivilege.indexOf("采集") > -1 && parseInt(this.state.showKey) !== 3 ? (
                  <div onClick={this.handleStartCheck}>
                    <Icon type="monitor" className="icon" />
                    <p>开始检查</p>
                  </div>
                ) : null}

                {parseInt(this.state.showKey) === 5 ? null : rolePrivilege.indexOf("审核报告") > -1 ||
                  rolePrivilege.indexOf("提交报告") > -1 ? (
                  <div onClick={this.handleStartReporting}>
                    <Icon type="read" className="icon" />
                    <p>开始报告</p>
                  </div>
                ) : rolePrivilege.indexOf("查看报告") > -1 ? (
                  <div onClick={this.handleStartReporting}>
                    <Icon type="read" className="icon" />
                    <p>查看报告</p>
                  </div>
                ) : null}

                {parseInt(this.state.showKey) === 5 ? null : rolePrivilege.indexOf("申请会诊") > -1 ? (
                  <div onClick={this.handleSubmitApply}>
                    <img
                      src={replyicon}
                      style={{
                        width: "33px",
                        marginLeft: "29.5px",
                        marginBottom: "5px",
                        marginTop: "4px",
                      }}
                      alt=""
                    ></img>
                    <p>申请会诊</p>
                  </div>
                ) : null}
                {parseInt(this.state.showKey) === 5 ? null : (
                  <div onClick={() => this.handleCancelApply()}>
                    <img
                      src={noapplyicon}
                      alt=""
                      style={{
                        width: "33px",
                        marginLeft: "27px",
                        marginBottom: "5px",
                        marginTop: "4px",
                      }}
                    ></img>
                    <p>取消会诊</p>
                  </div>
                )}

                {rolePrivilege.indexOf("删除病历") > -1 ? (
                  <div onClick={this.handleDelPatient}>
                    <Icon type="delete" className="icon" />
                    <p>删除报告</p>
                  </div>
                ) : null}
                {parseInt(this.state.showKey) === 5 ? null : (
                  <div onClick={this.handleUrging}>
                    <Icon type="bell" className="icon" />
                    <p>催办</p>
                  </div>
                )}
                {parseInt(this.state.showKey) === 1 ? (
                  <div onClick={this.handleCriticalCase}>
                    <img
                      src={critical}
                      alt=""
                      style={{
                        width: "30px",
                        marginLeft: "28px",
                        marginBottom: "4px",
                      }}
                    />
                    <p>危急病例</p>
                  </div>
                ) : null}

                {parseInt(this.state.showKey) === 1 ? (
                  <div onClick={this.handleCancelCriticalCase}>
                    <img
                      src={cancelcritical}
                      alt=""
                      style={{
                        width: "30px",
                        marginLeft: "28px",
                        marginBottom: "6px",
                        marginTop: "2px",
                      }}
                    />
                    <p>取消危急</p>
                  </div>
                ) : null}

                {parseInt(this.state.showKey) === 5 ? null : (
                  <div onClick={this.handleCollection}>
                    <img
                      src={star}
                      alt=""
                      style={{
                        width: "26px",
                        marginLeft: "31px",
                        marginBottom: "7px",
                        marginTop: "2px",
                      }}
                    ></img>
                    <p>病例收藏</p>
                  </div>
                )}
                {parseInt(this.state.showKey) === 5 ? null : parseInt(this.state.showKey) === 1 &&
                  parseInt(equipmentType) < 100 ? (
                  <div onClick={this.handleEcgSeverMsg}>
                    <img
                      src={accept}
                      alt=""
                      style={{
                        width: "26px",
                        marginLeft: "29px",
                        marginBottom: "7px",
                        marginTop: "2px",
                      }}
                    ></img>
                    <p>接收数据</p>
                  </div>
                ) : null}

                {parseInt(this.state.showKey) === 5 ? null : parseInt(this.state.showKey) === 1 &&
                  parseInt(equipmentType) < 100 ? (
                  <div onClick={this.handleBatchEcgSeverMsg}>
                    <img
                      src={receiving}
                      alt=""
                      style={{
                        width: "26px",
                        marginLeft: "29px",
                        marginBottom: "7px",
                        marginTop: "2px",
                      }}
                    ></img>
                    <p>批量接收</p>
                  </div>
                ) : null}
                {parseInt(this.state.showKey) === 5 ? null : (
                  <div onClick={this.handleApplyReferral}>
                    <img src={addReferral} alt="" style={{ width: "33px", marginLeft: "27px" }}></img>
                    <p>转诊申请</p>
                  </div>
                )}
                {parseInt(this.state.showKey) <= 3 ? (
                  <div onClick={this.exportList}>
                    <img src={exportExcel} alt="" style={{ width: "33px", marginLeft: "27px" }}></img>
                    <p>导出列表</p>
                  </div>
                ) : null}
                {parseInt(this.state.showKey) === 5 ? (
                  <div onClick={this.reReceive}>
                    <img
                      src={accept}
                      alt=""
                      style={{
                        width: "26px",
                        marginLeft: "29px",
                        marginBottom: "7px",
                        marginTop: "2px",
                      }}
                    ></img>
                    <p>重新接收</p>
                  </div>
                ) : null}
              </div>
            )}
          </>
        )}

        {isModalVisible ? (
          <Patient
            visible={isModalVisible}
            refreshTable={this.refreshTable}
            rowData={rowData}
            showKey={showKey}
            onClickRow={this.onClickRow}
            handleDelPatient={this.handleDelPatient}
            getTransferStatus={this.getTransferStatus}
            paitentRefData={this.paitentRefData}
            getEcgSeverData={this.getEcgSeverData}
            clickStatus={clickStatus}
            title={title}
            onRef={(ref) => {
              this.setState({
                isModalVisible: ref.isModalVisible,
                checkVisible: ref.checkVisible,
                NAME: ref.NAME,
                SEX_NAME: ref.SEX_NAME,
                EXAM_UID: ref.EXAM_UID,
                PATIENT_ID: ref.PATIENT_ID,
                presInspect: ref.presInspect,
              });
            }}
          />
        ) : null}

        {showColumn ? (
          <EditTable
            visible={showColumn}
            setTabData={
              parseInt(this.state.showKey) === 5
                ? JSON.parse(localStorage.getItem("electroencephalogramTabSetting")) ||
                  this.state.initElectroencephalogramCommonColumn
                : parseInt(this.state.showKey) === 6
                ? JSON.parse(localStorage.getItem("tranquillizationBloodColumn")) ||
                  this.state.initTranquillizationBloodColumn
                : JSON.parse(localStorage.getItem("applyTabSetting")) || this.state.initCommonColumn
            }
            updateParent={
              parseInt(this.state.showKey) === 5
                ? this.getElectroencephalogramCommonColumn
                : parseInt(this.state.showKey) === 6
                ? this.getTranquillizationBloodColumn
                : this.getCommonColumnInfo
            }
            onRef={(ref) => {
              this.setState({ showColumn: ref.showColumn });
            }}
          />
        ) : null}
        {applyVisible || applyType === "ApplyADD" ? (
          <ApplyConsulation
            visible={applyVisible}
            refreshTable={this.refreshTable}
            applyType={applyType}
            rowData={rowsData}
            transmiMsg={transmiMsg}
            transmiRate={transmiRate}
            applyConsulationType={applyConsulationType}
            setTransferStatus={this.getTransferStatus}
            showKey={showKey}
            onRef={(ref) => {
              this.setState({ applyVisible: ref });
            }}
            onApplyConsultRef={(ref) => {
              this.ApplyConsulation = ref;
            }}
          />
        ) : null}
        {bookmarkVisible ? (
          <Bookmark
            visible={bookmarkVisible}
            isEdit={isEdit}
            bookmarkdetail={bookmarkdetail}
            submitType={submitType}
            rowData={rowsData.length > 0 ? rowsData[0] : []}
            refreshTable={this.refreshTable}
            onRef={(ref) => {
              this.setState({ bookmarkVisible: ref });
            }}
          />
        ) : null}

        {revokeVisible ? (
          <RevokeConsultant
            visible={revokeVisible}
            showKey={showKey}
            refreshTable={this.refreshTable}
            rowData={rowsData.length > 0 ? rowsData[0] : []}
            onRef={(ref) => {
              this.setState({ revokeVisible: ref });
            }}
          ></RevokeConsultant>
        ) : null}

        <ApplyQueryTable
          getData={this.getData}
          setCount={this.getApplyCount}
          getMessageFn={this.props.getMessageFn}
          PageNo={this.state.PageNo}
          PageSize={this.state.PageSize}
          data={showKey}
          onRef={(ref) => {
            this.ApplyQueryTable = ref;
          }}
          updateParentLoadingState={this.updateParentLoadingState}
        />

        {checkVisible ? (
          <StartCheck
            visible={checkVisible}
            rowData={rowData}
            name={this.state.NAME}
            sex={this.state.SEX_NAME}
            patientId={this.state.PATIENT_ID}
            holterData={holterData}
            addStatus={this.state.addStatus}
            setTransferStatus={this.getTransferStatus}
            onRef={(ref) => {
              this.setState({ checkVisible: ref, holterData: "" });
            }}
          />
        ) : null}

        {batchReceiveVisible ? (
          <BatchReceive
            visible={batchReceiveVisible}
            refreshTable={this.refreshTable}
            sucBatchMsg={this.state.sucBatchMsg}
            errBatchMsg={this.state.errBatchMsg}
            infoBatchMsg={this.state.infoBatchMsg}
            getBatchNum={this.state.getBatchNum}
            getbatchTableList={this.state.getbatchTableList}
            onRef={(ref) => {
              this.setState({
                batchReceiveVisible: ref,
                sucBatchMsg: "",
                errBatchMsg: "",
                infoBatchMsg: "",
                getBatchNum: "",
                getbatchTableList: "",
              });
            }}
          />
        ) : null}

        {this.state.deepSeekModalVisible ? (
          <DeepSeekModal
            visible={this.state.deepSeekModalVisible}
            deepSeekModalPatientPart={this.state.deepSeekModalPatientPart}
            deepSeekModalType={this.state.deepSeekModalType}
            onRef={(ref) => {
              this.setState({
                deepSeekModalVisible: ref,
              });
              this.refreshTable();
            }}
          ></DeepSeekModal>
        ) : null}

        {this.state.criticalVisible ? (
          <CriticalCaseInfo
            visible={this.state.criticalVisible}
            rowData={rowData}
            refreshTable={this.refreshTable}
            onRef={(ref) => {
              this.setState({ criticalVisible: ref });
            }}
          />
        ) : null}

        <div className="eleWrap applyTd" style={{ background: "#fff" }}>
          <Tabs activeKey={showKey + ""} type="card" onChange={this.handleTabKey}>
            {settingVal.waitImproved ? (
              <TabPane key="4" tab="待完善">
                <Spin size="large" spinning={tabsloading} tip="Loading...">
                  <Table
                    columns={waitColumn}
                    dataSource={queryTableData}
                    rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
                    scroll={{ x: 380, scrollToFirstRowOnChange: true }}
                    pagination={{
                      total: this.state.RowCount,
                      current: this.state.PageNo,
                      onChange: this.onChangePage,
                    }}
                    rowSelection={{
                      selectedRowKeys,
                      onChange: this.onSelectChange,
                      // onSelect: this.onSelect,
                      // onSelectAll: this.onSelectAll
                    }}
                    rowClassName={this.setRowClassName}
                    onRow={(record) => {
                      return {
                        onClick: (e) => {
                          this.onClickRow(record);
                        }, //点击行
                        onDoubleClick: (e) => {
                          this.handleDoubleClicks(record);
                        }, //双击行
                      };
                    }}
                  />
                </Spin>
              </TabPane>
            ) : null}
            {custService === 1 || menuType.indexOf("静息心电") > -1 ? (
              <TabPane
                key="1"
                tab={
                  <Badge size="default" count={applyCount.ECG}>
                    <p className="badgeText">静息心电</p>
                  </Badge>
                }
              >
                <Spin size="large" spinning={tabsloading} tip="Loading...">
                  <Table
                    columns={commonColumn}
                    dataSource={queryTableData}
                    rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
                    scroll={{ x: 380, scrollToFirstRowOnChange: true }}
                    pagination={{
                      total: this.state.RowCount,
                      current: this.state.PageNo,
                      onChange: this.onChangePage,
                    }}
                    rowSelection={{
                      selectedRowKeys,
                      onChange: this.onSelectChange,
                    }}
                    onRow={(record) => {
                      return {
                        onClick: (e) => {
                          this.onClickRow(record);
                        }, //点击行
                        onDoubleClick: (e) => {
                          this.handleDoubleClicks(record);
                        }, //双击行
                      };
                    }}
                    rowClassName={this.setRowClassName}
                    onHeaderRow={(column) => {
                      return {
                        onDoubleClick: (e) => this.handleHeader(column), //修改表头
                      };
                    }}
                  />
                </Spin>
              </TabPane>
            ) : null}
            {custService === 1 || menuType.indexOf("动态心电") > -1 ? (
              <TabPane
                key="2"
                tab={
                  <Badge size="default" count={applyCount.Holter}>
                    <p className="badgeText">动态心电</p>
                  </Badge>
                }
              >
                <Spin size="large" spinning={tabsloading} tip="Loading...">
                  <Table
                    columns={commonColumn}
                    dataSource={queryTableData}
                    rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
                    scroll={{ x: 380, scrollToFirstRowOnChange: true }}
                    pagination={{
                      total: this.state.RowCount,
                      current: this.state.PageNo,
                      onChange: this.onChangePage,
                    }}
                    rowSelection={{
                      selectedRowKeys,
                      onChange: this.onSelectChange,
                    }}
                    onRow={(record) => {
                      return {
                        onClick: (e) => {
                          this.onClickRow(record);
                        }, //点击行
                        onDoubleClick: (e) => {
                          this.handleDoubleClicks(record);
                        }, //双击行
                      };
                    }}
                    rowClassName={this.setRowClassName}
                    onHeaderRow={(column) => {
                      return {
                        onDoubleClick: (e) => this.handleHeader(column), //修改表头
                      };
                    }}
                  />
                </Spin>
              </TabPane>
            ) : null}
            {custService === 1 || menuType.indexOf("动态血压") > -1 ? (
              <TabPane
                key="3"
                tab={
                  <Badge size="default" count={applyCount.BloodPressure}>
                    <p className="badgeText">动态血压</p>
                  </Badge>
                }
              >
                <Spin size="large" spinning={tabsloading} tip="Loading...">
                  <Table
                    columns={commonColumn}
                    dataSource={queryTableData}
                    rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
                    scroll={{ x: 380, scrollToFirstRowOnChange: true }}
                    pagination={{
                      total: this.state.RowCount,
                      current: this.state.PageNo,
                      onChange: this.onChangePage,
                    }}
                    rowSelection={{
                      selectedRowKeys,
                      onChange: this.onSelectChange,
                    }}
                    onRow={(record) => {
                      return {
                        onClick: (e) => {
                          this.onClickRow(record);
                        }, // 点击行
                        onDoubleClick: (e) => {
                          this.handleDoubleClicks(record);
                        }, //双击行
                      };
                    }}
                    rowClassName={this.setRowClassName}
                    onHeaderRow={(column) => {
                      return {
                        onDoubleClick: (e) => this.handleHeader(column), //修改表头
                      };
                    }}
                  />
                </Spin>
              </TabPane>
            ) : null}
            {menuType.indexOf("脑电地形图") > -1 ? (
              <TabPane
                key="5"
                tab={
                  <Badge size="default" count={applyCount.EEG}>
                    <p className="badgeText">脑电地形图</p>
                  </Badge>
                }
              >
                <Spin size="large" spinning={tabsloading} tip="Loading...">
                  <Table
                    columns={electroencephalogramCommonColumn}
                    dataSource={queryTableData}
                    rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
                    scroll={{ x: 380, scrollToFirstRowOnChange: true }}
                    pagination={{
                      total: this.state.RowCount,
                      current: this.state.PageNo,
                      onChange: this.onChangePage,
                    }}
                    rowSelection={{
                      selectedRowKeys,
                      onChange: this.onSelectChange,
                    }}
                    onRow={(record) => {
                      return {
                        onClick: (e) => {
                          this.onClickRow(record);
                        }, // 点击行
                        onDoubleClick: (e) => {
                          this.handleDoubleClicks(record);
                        },
                      };
                    }}
                    rowClassName={this.setRowClassName}
                    onHeaderRow={(column) => {
                      return {
                        onDoubleClick: (e) => this.handleHeader(column), //修改表头
                      };
                    }}
                  />
                </Spin>
              </TabPane>
            ) : null}
            {settingVal.showTranquillizationBlood ? (
              <TabPane
                key="6"
                tab={
                  <Badge size="default">
                    <p className="badgeText">常规血压</p>
                  </Badge>
                }
              >
                <Spin size="large" spinning={tabsloading} tip="Loading...">
                  <Table
                    columns={tranquillizationBloodColumn}
                    dataSource={queryTableData}
                    rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
                    scroll={{ x: 380, scrollToFirstRowOnChange: true }}
                    pagination={{
                      total: this.state.RowCount,
                      current: this.state.PageNo,
                      onChange: this.onChangePage,
                    }}
                    rowSelection={{
                      selectedRowKeys,
                      onChange: this.onSelectChange,
                    }}
                    rowClassName={this.setRowClassName}
                    onHeaderRow={(column) => {
                      return {
                        onDoubleClick: (e) => this.handleHeader(column), //修改表头
                      };
                    }}
                  />
                </Spin>
              </TabPane>
            ) : null}
          </Tabs>
        </div>
        {this.state.ecgStartReportBtn ? (
          <Modal
            visible={this.state.ecgStartReportBtn}
            className="ecgStartReportBox"
            footer={false}
            width="100%"
            style={{ top: 0, minWidth: "1200px" }}
            onCancel={this.cancelEcgReport}
          >
            <EcgStartReport rowData={this.state.rowData} refreshTable={this.refreshTable} />
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default RemoteApply;
